import { registerPlugin } from '@capacitor/core';
import { isAndroid } from './Platform';

/**
 * Thin wrapper around the custom `TimerNotification` Android Capacitor
 * plugin. Shows a persistent chronometer notification on the Lock Screen
 * while a timer is running — Android's closest analogue to an iOS Live
 * Activity. No-op on iOS and web.
 */
const TimerNotification = registerPlugin('TimerNotification');

export async function start({ endAt, title, body }) {
    if (!isAndroid()) return;
    try {
        await TimerNotification.start({
            endAt,
            title: title || 'Meditation Timer',
            body: body || 'Session in progress'
        });
    } catch (err) {
        console.warn('[AndroidTimerNotification] start failed', err);
    }
}

export async function stop() {
    if (!isAndroid()) return;
    try {
        await TimerNotification.stop();
    } catch (err) {
        console.warn('[AndroidTimerNotification] stop failed', err);
    }
}

export default { start, stop };
